import * as React from "react";

export interface AppSettings {
  adminApplicationUrl: string;
  applicationName: string;
  applicationUrl: string;
  homeUrl: string;
  certsyHirerLandingUrl: string;
  certsySignInUrl: string;
  env?: "development" | "staging" | "production";
  facebookAppId: string;
  omnitureScriptUrl: string;
  seekVolunteerUrl: string;
  supportEmail?: string;
  showAdviceTipsSubscribe?: boolean;
  showApplicationNudge?: boolean;
  showFiltersInSearch?: boolean;
  socialTradersFeatureFlag?: boolean;
}

interface ServerStaticContext {
  appSettings: AppSettings;
}

export const ServerStatic = React.createContext<
  ServerStaticContext | undefined
>(undefined);

export const ServerStaticProvider: React.FC<ServerStaticContext> = ({
  appSettings,
  children,
}) => {
  const value = React.useMemo(() => {
    return {
      appSettings,
    };
  }, []);

  return (
    <ServerStatic.Provider value={value}>{children}</ServerStatic.Provider>
  );
};

export const useServerStatic = (): ServerStaticContext => {
  const context = React.useContext(ServerStatic);

  if (!context) {
    throw Error("useServerStatic used outside a global Provider");
  }

  return context;
};

export const useAppSettings = (): AppSettings => {
  const { appSettings } = useServerStatic();

  return appSettings;
};
